import { useEffect, useRef, useState, useMemo } from 'react';
import { Field, Form, FormSubmission, TeamModuleConfiguration } from 'src/API';
import { useDispatch, useSelector } from 'src/store';
import { thunks } from 'src/thunks/process-module';

export const useForms = (
  processModuleID: string,
): {
  forms: Form[];
  teamModuleConfiguration?: TeamModuleConfiguration | null;
  fields: Field[];
  formSubmissions: { [processModuleID: string]: FormSubmission[] } | null | undefined;
} => {
  const dispatch = useDispatch();
  const hasQueried = useRef(false); // Use ref to persist state without triggering re-renders
  const forms = useSelector((state) => state.processModule.forms);
  const fields = useSelector((state) => state.processModule.fields);
  const formSubmissions = useSelector((state) => state.processModule.formSubmissions);
  const teamModuleConfiguration = useSelector((state) => state.team.current?.moduleConfigurations);

  useEffect(() => {
    if (!hasQueried.current && processModuleID) {
      hasQueried.current = true; // Mark as queried
      dispatch(thunks.getFields());
      dispatch(thunks.getFormsForProcessModule(processModuleID));
      dispatch(thunks.getFormSubmissionByProcessModuleId(processModuleID));
      dispatch(thunks.getProcessModules());
    }
  }, [dispatch, processModuleID]);

  const filteredForms = useMemo(() => {
    return (
      forms
        ?.filter((f) => f.processModuleID === processModuleID)
        ?.sort((a, b) => (a.sequence || Infinity) - (b.sequence || Infinity)) ?? []
    );
  }, [forms, processModuleID]);

  return {
    forms: filteredForms,
    fields,
    teamModuleConfiguration: teamModuleConfiguration?.find((c) => c?.processModuleID === processModuleID),
    formSubmissions,
  };
};
